import { ReactNode } from "react";
import ToolTip from "components/design/toolTip";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { formatDate } from "utils/formatDate";
import { getFilingDetailStatus } from "utils/filingsTimeline/getFilingDetailStatus";
import { useFilingEntityName } from "./useFilingEntityName";

type TimelineFilingTooltipProps = {
  filing: TimelineFilingRow;
  children: ReactNode;
};

const DETAIL_CLASS = "t-text-caption t-text-neutral-40";

export const TimelineFilingTooltip = ({
  filing,
  children,
}: TimelineFilingTooltipProps) => {
  const entityName = useFilingEntityName(filing);

  const tooltipContent = (
    <div className="t-flex t-flex-col t-gap-0.5 t-text-left">
      <div className="t-text-body-sm t-text-white">{filing.name}</div>

      {entityName && <div className={DETAIL_CLASS}>Entity: {entityName}</div>}

      <div className={DETAIL_CLASS}>
        Deadline: {formatDate(filing.deadline)}
      </div>

      <div className="t-flex t-items-center t-gap-2">
        <span className={DETAIL_CLASS}>Status:</span>
        <span className="t-text-caption t-text-neutral-50">
          {getFilingDetailStatus(filing)}
        </span>
      </div>
    </div>
  );

  return (
    <ToolTip
      text={tooltipContent}
      side="top"
      propClass="t-max-w-64"
      disableHoverableContent
    >
      {children}
    </ToolTip>
  );
};
